import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private isUserScrolling = false;
  private scrollInterval: any = null;
  private container: HTMLElement | null = null;
  private scrollHandler: ((event: Event) => void) | null = null;


  scrollBottom(containerId: string): () => void {
    this.stopScrolling();

    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Container with ID ${containerId} not found`);
      return;
    }

    this.container = container;

    this.scrollHandler = () => this.handleUserScroll();
    container.addEventListener('scroll', this.scrollHandler);

    // Start the scroll interval
    this.scrollInterval = setInterval(() => {
      if (!this.isUserScrolling) {
        container.scrollTop = container.scrollHeight;
      }
    }, 100);
    return () => this.stopScrolling();
  }

  private handleUserScroll(): void {
    const isAtBottom = this.container.scrollHeight - this.container.scrollTop <= this.container.clientHeight + 50;

    this.isUserScrolling = !isAtBottom;
  }

  stopScrolling(): void {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }

    if (this.container && this.scrollHandler) {
      this.container.removeEventListener('scroll', this.scrollHandler);
      this.container = null;
      this.scrollHandler = null;
    }

    this.isUserScrolling = false;
  }
}
